import AllBaseInformationBreadcrumb from '@components/shared/claim_group/base_information/AllBaseInformationBreadcrumb';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Loading } from '@rd-web-markets/shared/dist/util';
import claimGroupContractorsService from '@services/claim_groups/claim_group_contractors_service';
import { ContractorsRowHeader } from '@rd-web-markets/de/dist/financialSection/contractors/ContractorRowHeader';
import { ContractorsRow } from '@rd-web-markets/de/dist/financialSection/contractors/ContractorsRow';
import { Row, Col, Card } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Navigation } from '@rd-web-markets/de/dist/allBase/Navigation';
import claimContractorsService from '@rd-web-markets/de/dist/services/claim/claim_contractors.service';
import SidebarPortal from '@rd-web-markets/shared/dist/util/SidebarPortal';
export const ContractorsSection = _ref => {
  let {
    claimGroup,
    accountType,
    type
  } = _ref;
  const dispatch = useDispatch();
  const [claimContractors, setClaimContractors] = useState(null);
  useEffect(() => {
    const fetchClaimGroup = async () => {
      try {
        const claimContractors = await claimGroupContractorsService.all(claimGroup.id, type);
        setClaimContractors(claimContractors);
      } catch (e) {
        dispatch(handleError(e.description));
      }
    };
    fetchClaimGroup();
  }, [claimGroup]);
  const handleDelete = async index => {
    const contractor = claimContractors[index];
    if (contractor.id) {
      try {
        await claimContractorsService.delete(contractor);
        const contractors = await claimGroupContractorsService.all(claimGroup.id);
        setClaimContractors(contractors);
      } catch (error) {
        dispatch(handleError(error));
      }
    } else {
      const newContractors = [...claimContractors];
      newContractors.splice(index, 1);
      setClaimContractors(newContractors);
    }
  };
  const refreshClaim = () => {};
  if (!claimGroup || !claimContractors) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarPortal, {
    headerItem: {
      link: "companies/".concat(claimGroup.company_id, "/master"),
      text: claimGroup.company.name
    }
  }), /*#__PURE__*/React.createElement(AllBaseInformationBreadcrumb, {
    claimGroup: claimGroup
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Navigation, {
    type: type,
    page: 'contractors',
    claim_group: claimGroup,
    accountType: accountType
  })), /*#__PURE__*/React.createElement(Card.Body, null, claimContractors.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    size: "sm",
    className: "pt-4"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(ContractorsRowHeader, {
    showTypeAndYear: true
  })), /*#__PURE__*/React.createElement("tbody", null, claimContractors.map((contractor, index) => {
    return /*#__PURE__*/React.createElement(ContractorsRow, {
      showTypeAndYear: true,
      key: index,
      index: index,
      claim: contractor.claim,
      handleDelete: () => handleDelete(index),
      claimContractors: claimContractors,
      setClaimContractors: setClaimContractors,
      refreshClaim: refreshClaim,
      handleError: handleError
    });
  })))) : /*#__PURE__*/React.createElement(Row, {
    className: "pt-5 pb-5 text-center"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-center text-muted"
  }, "No data"))))));
};